var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptySearch = function SvgEmptySearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.68 14h-.79l-.28-.27a6.47 6.47 0 0 0 1.57-4.23 6.5 6.5 0 0 0-6.5-6.5C7.26 3 4.46 5.64 4.21 9h2.02c.25-2.25 2.13-4 4.45-4 2.49 0 4.5 2.01 4.5 4.5s-2.01 4.5-4.5 4.5c-.17 0-.33-.03-.5-.05v2.02c.17.02.33.03.5.03 1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L21.67 19z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.65 10.82-2.47 2.47-2.47-2.47-.71.71L4.47 14 2 16.47l.71.71 2.47-2.47 2.47 2.47.71-.71L5.89 14l2.47-2.47z"
  })));
};
export default SvgEmptySearch;